<template>
  <CurrencyField
    :id="`tender-amount-${index}`"
    :name="fieldName"
    :label="t('sites.singleSite.financialConfig.mealPlans.form.tenders.tenderSetup.rates.amount')"
    :placeholder="
      t(
        'sites.singleSite.financialConfig.mealPlans.form.tenders.tenderSetup.rates.amountPlaceholder',
      )
    "
    :required="true"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

// Define props
defineProps({
  fieldName: {
    type: String,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
});

// Set localization
const { t } = useI18n();
</script>
